import { defineComponent } from 'vue'
import { getTreeTotal } from '@/Mixins/SigmaClientNew/GeneralLedgerWorksheet/Localtreedatasource.js'
/*
* AG Grid Methods here
*/
export default defineComponent({
  methods: {
    pinSummaryTotalRow (gridApi) {
      if (!this.localTree) return
      const current = { trans_number: 'Total', amount: getTreeTotal(this.localTree) }
      gridApi.setPinnedBottomRowData([current])
    },

    pinTotalRow (gridApi) {
      if (!this.localTree) return
      const currentTotal = getTreeTotal(this.localTree)

      if (!this.originalTotals) {
        // Captured once, on first call after a fresh report load — same intent
        // as before (a snapshot to diff "changes this session" against).
        this.originalTotals = { account_name: 'Starting Total', amount: currentTotal }
      }

      const original = this.originalTotals
      const current = { account_name: 'Current Total', amount: currentTotal }
      const changed = {
        account_name: 'Changes This Session',
        amount: current.amount - original.amount
      }
      gridApi.setPinnedBottomRowData([original, changed, current])
    },

    // Redraw rows, useful to show changes and other styles
    redrawCurrentRow (rowNode) {
      if (!rowNode) {
        const cell = this.gridApi.getFocusedCell()
        rowNode = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex)
      }
      if (!rowNode) return
      this.gridApi.redrawRows({ rowNodes: [rowNode] })
    },

    changeGrouping (expand = true) {
      if (this.displayOptions.groupingLevel < 0) this.displayOptions.groupingLevel = 0

      this.gridApi.forEachNode((node) => {
        if (expand === true) {
          node.setExpanded(true)
          this.displayOptions.groupingLevel++
        } else if (expand === false) {
          node.setExpanded(false)
          this.displayOptions.groupingLevel--
          if (node.level < this.displayOptions.groupingLevel - 1) {
            node.setExpanded(true)
          }
        }
      })
    },

    expandAll () {
      this.gridApi.expandAll()
    },

    collapseAll () {
      this.gridApi.collapseAll()
    },

    // Test function
    log (value) {
      console.log(value)
    },

    intlNumberFormatter (number, locale, options) {
      if (typeof number === 'string') {
        if (number.includes('(')) {
          return number
        } else {
          number = parseFloat(number)
        }
      }
      if (typeof number !== 'number' && !isNaN(Number(number))) return null
      const hideDecimals = (this.displayOptions || {}).hideDecimals || false
      const useParentheses = (this.displayOptions || {}).showNegativesInParenthesesInWorkSheet || false

      if (!locale) locale = 'en-us'

      if (!options) {
        options = {
          style: 'decimal',
          useGrouping: true,
          minimumFractionDigits: hideDecimals ? 0 : 2,
          maximumFractionDigits: hideDecimals ? 0 : 2
        }
      }

      let result = new Intl.NumberFormat(locale, options).format(number)

      // -0 should be just 0
      if (result === '-0' || result === '-0.00') {
        result = new Intl.NumberFormat(locale, options).format(0)
      }

      // currencySign option is not working on many browsers so manually handle
      if (useParentheses && result.slice(0, 1) === '-') {
        result = '(' + result.slice(1) + ')'
      }

      return result
    },

    // Send focus back to next cell
    setCellFocus (cell) {
      if (!cell) cell = this.gridApi.getFocusedCell()
      if (cell) this.gridApi.setFocusedCell(cell.rowIndex, cell.column)
    },

    getContextMenuItems (params) {
      const account = params.node.data && !params.node.group ? params.node.data.trans_number : params.value
      const normal = [
        {
          name: 'Drill Down on ' + account,
          action: () => {
            this.drillDown()
          }
        }
      ]

      const group = [
        {
          name: 'No available actions',
          disabled: true
        }
      ]

      return params.node.group ? group : normal
    }
  }
})
